import { computed, getCurrentInstance } from 'vue';
import { MicrosoftEntraId, OneLogin, Okta, UserSettingState, UserSetting } from './types';

export function useUsrSettingStore() {
    const vm = getCurrentInstance();
    const state = computed(() => vm.proxy.$store.state.userSetting as UserSettingState);

    const importIdpDetails = computed(() => state.value.importIdp);
    const connectionIdpDetails = computed(() => state.value.connectionIdp);
    const updateDetails = computed(() => state.value.update);
    const showDetails = computed(() => state.value.show);
    const userSettingDetails = computed(() => state.value.userSetting);
    const beforeLoginDetails = computed(() => state.value.beforeLogin);

    async function show(category: string) {
        await vm.proxy.$store.dispatch('userSetting/show', category);
    }
    async function update(params: { userSetting: UserSetting; category: string }) {
        await vm.proxy.$store.dispatch('userSetting/update', params);
    }
    async function beforeLogin() {
        await vm.proxy.$store.dispatch('userSetting/beforeLogin');
    }
    async function dealError() {
        await vm.proxy.$store.dispatch('userSetting/dealError');
    }

    return {
        importIdpDetails,
        connectionIdpDetails,
        updateDetails,
        showDetails,
        userSettingDetails,
        beforeLoginDetails,
        show,
        update,
        beforeLogin,
        dealError,
    };
}

export function useIdpStore() {
    const vm = getCurrentInstance();

    async function import_idp() {
        await vm.proxy.$store.dispatch('userSetting/import_idp');
    }
    async function connection_idp(params: {
        saml: { provider: string };
        microsoftEntraId: MicrosoftEntraId;
        oneLogin: OneLogin;
        okta: Okta;
    }) {
        await vm.proxy.$store.dispatch('userSetting/connection_idp', params);
    }

    return {
        import_idp,
        connection_idp,
    };
}
